export async function shareReferralMessage({
  shareData,
  trackReferralInvitationSent,
}: {
  shareData: ShareData;
  trackReferralInvitationSent: () => void;
}): Promise<boolean> {
  let linkCopiedToClipboard = false;
  // navigator.share doesn't exist on certain browsers
  if (navigator.share) {
    try {
      await navigator.share(shareData).then(() => {
        trackReferralInvitationSent();
      });
    } catch (error) {
      if (error?.toString().includes('AbortError')) {
        // User canceled the share action, swallow exception
      } else {
        // Throw exception so sentry catches it
        throw error;
      }
    }
  } else {
    await navigator.clipboard
      .writeText(shareData.text ?? '')
      .then(() => (linkCopiedToClipboard = true));
  }

  return linkCopiedToClipboard;
}
